<template>
    <ValidationProvider
        v-slot="{ errors, validate }"
        name="eBoothTemplate"
        vid="eBoothTemplate"
        :rules="validationRules"
        :custom-messages="{
            required: $t('lbl_emp2_PleaseSelect'),
            min_value: $t('lbl_emp2_PleaseSelect'),
        }"
    >
        <input type="hidden" :value="Temp_Value" />
        <div class="LogoImgTheme" :class="{ 'has-error': errors.length > 0 }">
            <div v-for="(item, index) in ThemeList" :key="index">
                <div class="round_Outside">
                    <div :class="(Temp_Value == item.Id ? 'clickRound' : 'NoclickRound') + ' round'"
                        @click="changeRound(item.Id, validate)">
                        <img style="height: 39px; width: 39px;" :src="cdnURL + 'CompanyInfo_Theme_' + item.Text + '.png'" />
                        <div v-if="item.IsPrime" class="PrimeBanna">
                            {{ $t("lbl_EMPBE_CompanyInfo_Prime") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-form-invalid-feedback :state="false" v-if="errors.length" style="display: block;">
            {{ $t('lbl_emp2_PleaseSelect') }}
        </b-form-invalid-feedback>
    </ValidationProvider>
</template>
<script>

export default {
    props: {
        value: { default: 0 },
        /** When false, skip required rule (parent already hides the field when not needed). */
        isRequired: { type: Boolean, default: true },
    },
    inject: ["permissionData"],
    data() {
        return {
            ThemeList:
                [
                    {
                        Id: 1,
                        Text: "Purple",
                        IsPrime: false
                    },
                    {
                        Id: 2,
                        Text: "Yellow",
                        IsPrime: false
                    },
                    {
                        Id: 3,
                        Text: "Blue",
                        IsPrime: false
                    },
                    {
                        Id: 4,
                        Text: "Green",
                        IsPrime: false
                    },
                    {
                        Id: 5,
                        Text: "Grey",
                        IsPrime: false
                    }

                ],
            cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/Images/CompanyInfo/",
            Temp_Value: this.value || 0
        }
    },
    watch: {
        value() {
            // Keep 0 as "unselected"; do not auto-pick a theme
            this.Temp_Value = Number(this.value) || 0;
        },
        Temp_Value() {
            this.$emit('input', this.Temp_Value);
        }
    },
    computed: {
        validationRules() {
            return this.isRequired ? { required: true, min_value: 1 } : {};
        },
        APlusBooth() {
            if (this.permissionData) {
                return ["A+"].includes(this.permissionData["Type"]);
            } else {
                return false;
            }
        },

    },
    mounted() {
        if (this.APlusBooth)
            this.ThemeList.unshift
                (
                    { Id: 6, Text: "golden", IsPrime: true }
                );
    },
    methods: {
        changeRound(index, validate) {
            this.Temp_Value = index;
            if (typeof validate === 'function') {
                this.$nextTick(() => validate(this.Temp_Value));
            }
        }
    }

}
</script>
<style lang="scss" scoped>
.LogoImgTheme {
    overflow: hidden;

    &.has-error .NoclickRound {
        border: 2px solid #dc3545;
    }

    .round_Outside {
        float: left;
        padding: 10px;
    }

    .round {
        border-radius: 50%;
        position: relative;
    }

    .clickRound {
        border: 2px solid #7366FF;
    }

    .NoclickRound {
        border: 2px solid #ffffff;

    }

    .PrimeBanna {
        color: rgba(0, 0, 0, 0.80);
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        word-wrap: break-word;
        padding: 2px 4px;
        right: -20px;
        top: -10px;
        position: absolute;
        background: #FFD02C;
        border-radius: 25px;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
        display: inline-flex
    }
}
</style>
